import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetCoachListByProgramId = async function(programId) {
  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  const result = await queryThaisookViewBigQuery({
    info: 'get coachList by Program',
    query: `
        select 
            U.uid, 
            concat(U.firstname, ' ', U.lastname) name, 
            O.name org,
            U.phoneNumber,
            U.pictureUrl
        from 
            thaisook_view.users U
            join thaisook_view.program P on U.uid IN UNNEST(P.coachList)
            left join thaisook_view.organization O on O.orgId = U.orgId
        where 
            P.programId='${programId}'
        `
  });
  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bqGetCoachListByProgramId;
